"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHundredPercentSnapPoints = void 0;
const isHundredPercentSnapPoints = (snapPoints) => Array.isArray(snapPoints) &&
    snapPoints.length === 1 &&
    snapPoints[0] === '100%';
exports.isHundredPercentSnapPoints = isHundredPercentSnapPoints;
